// first-party cookie settings
const KEY = '__worknet_cid';
const DAYS = 365;
const DOMAIN =
  location.hostname.split('.').length > 2
    ? `; Domain=.${location.hostname.split('.').slice(-2).join('.')}`
    : '';

function readCookie(name = KEY) {
  return document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${name}=`))
    ?.split('=')[1];
}

function writeCookie(val: string, name = KEY, days = DAYS) {
  document.cookie = `${name}=${val}; Path=/; Max-Age=${days * 86400}; SameSite=Lax; Secure${DOMAIN}`;
}

export function getDeviceId() {
  const idFromCookie = readCookie(KEY);
  const idFromStorage = localStorage.getItem(KEY);
  const id = idFromCookie || idFromStorage || crypto.randomUUID();

  if (idFromCookie !== id) {
    writeCookie(id);
  }
  if (idFromStorage !== id) {
    localStorage.setItem(KEY, id);
  }

  // 4) (optional) get a server signature so b.com can trust it later
  //    Your server HMACs {cid, issuedAt} and returns {sig, issuedAt}
  // try {
  //   const res = await fetch('https://b.com/cid/sign', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ cid }),
  //   });
  //   if (res.ok) {
  //     const { sig, t } = await res.json();
  //     // store alongside for tamper detection (still first-party)
  //     document.cookie = `cid_sig=${sig}.${t}; Path=/; Max-Age=${DAYS * 86400}; SameSite=Lax; Secure${DOMAIN}`;
  //   }
  // } catch (_) {}

  return id;
}
